import { Button, FormControl, FormLabel, Input, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay } from "@chakra-ui/react";
import { ContatoType } from "models/contato_type";
import InputMask from "react-input-mask";
interface IOrderContact {
    showModal :(show: boolean, type?: string) => void;
    show: boolean;
    save:(type: string, action: string) => void;
    loading: boolean;
    selectedContact : ContatoType | undefined;
    type: string;
    changeInput : (tipo: string, value: any) => void;

}

const OrderContact = ({show, showModal, save, loading, selectedContact, type, changeInput}:IOrderContact) => {

    const action =  selectedContact === null ? "insert" : "edit";
    const mask  = "(99) 99999-9999";
    return(
        <Modal
        onClose={() => {
          showModal(false, type);
        }}
        size={"2xl"}
        isOpen={show}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            {selectedContact != null ? "Editar Contato" : "Novo Contato"}
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
        

            <FormControl>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                mb="8px"
              >
                Contato Responsável
              </FormLabel>
                <Input
                  isRequired={true}
                  variant="auth"
                  fontSize="sm"
                  ms={{ base: "0px", md: "0px" }}
                  type="text"
                  placeholder="Preencha o contato responsável"
                  onBlur={(e) => (changeInput("contactPerson",e.target.value))}
                  defaultValue={selectedContact?.nome}
                  mb="24px"
                  fontWeight="500"
                 
                  size="lg"
                />
            </FormControl>

            <FormControl>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"

                mb="8px"
              >
                Email do Contato
              </FormLabel>
                <Input
                  isRequired={true}
                  variant="auth"
                  fontSize="sm"
                  ms={{ base: "0px", md: "0px" }}
                  type="text"
                  placeholder="Preencha o email do contato"
                  onBlur={(e) => (changeInput("contactEmail",e.target.value))}
                  defaultValue={selectedContact?.email}
                  mb="24px"
                  fontWeight="500"
                 
                  size="lg"
                />
            </FormControl>

            <FormControl>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                mb="8px"
              >
                Telefone do Contato
              </FormLabel>
                <Input
                  isRequired={true}
                  variant="auth"
                  fontSize="sm"
                  ms={{ base: "0px", md: "0px" }}
                  type="text"
                  placeholder="Preencha o telefone de contato"
                  onBlur={(e) => (changeInput("contactPhone",e.target.value))}
                  defaultValue={selectedContact?.telefone}
                  mb="24px"
                  fontWeight="500"
                  as={InputMask}
                  mask={mask}
                 
                  size="lg"
                />
            </FormControl>
          </ModalBody>
              <ModalFooter>
                <Button
                  onClick={() => {
                    showModal(false, type);
                  }}
                  variant="outline"
                  marginRight={4}
                >
                  Fechar
                </Button>
                <Button
                  onClick={() => {
                    save(type, action);
                  }}
                  colorScheme="brand"
                  isLoading={loading}
                >
                  Salvar
                </Button>
              </ModalFooter>
            </ModalContent>
          </Modal>
    );

}
export default OrderContact;